import { faEdit } from '~components/icon';
import { Column } from '~components/table-view';
import { linkCellRender } from '~components/table-view/columnRenderers';

const columnsFactory = (openEdit: (id: string) => void) => {
  const columns: Column[] = [
    {
      id: 'reference',
      header: 'Reference',
      type: 'text',
      classNames: {
        header: 'cell-align-left',
        column: 'cell-align-left',
      },
      renderReadOnly: linkCellRender((row) => openEdit(row.id), faEdit, {
        classNames: {
          cell: 'px-1',
        },
      } as any),
    },
    // {
    //   id: 'status',
    //   header: 'Status',
    //   type: 'text',
    //   classNames: {
    //     header: 'cell-align-center',
    //     column: 'cell-align-center',
    //   },
    // },
    {
      id: 'total_paid',
      header: 'Total Paid',
      type: 'currency',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'gov_contributions',
      header: 'Government Contributions',
      type: 'currency',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'co_contributions',
      header: 'Co-Contributions',
      type: 'currency',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'clients_count',
      header: 'Clients',
      type: 'text',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'unresolved_count',
      header: 'Unresolved Items',
      type: 'text',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
  ];

  return columns;
};

export default columnsFactory;
